import React from 'react';
import { Box, Button } from '@mui/material';
import { TableFilterToolbarProps } from './types';

/**
 * Standardized toolbar for table filter actions.
 *
 * Provides "Apply Filters" and "Clear All" buttons with consistent styling,
 * and allows for additional action buttons via children.
 */
export const TableFilterToolbar: React.FC<TableFilterToolbarProps> = ({
  hasPendingFilters,
  hasActiveFilters,
  onApply,
  onClear,
  disabled,
  children,
  sx,
  alwaysShow = false,
}) => {
  const showFilterButtons = alwaysShow || hasPendingFilters || hasActiveFilters;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 4,
        ...sx,
      }}
    >
      {/* Left side: Action buttons (Add, Export, etc.) */}
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
        {children}
      </Box>

      {/* Right side: Filter action buttons */}
      {showFilterButtons && (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
          <Button
            sx={{
              height: '36px',
              width: '120px',
              borderRadius: 2,
              marginTop: '10px',
              ...(hasPendingFilters && {
                backgroundColor: 'primary.main',
                color: 'white',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }),
            }}
            variant={hasPendingFilters ? 'contained' : 'outlined'}
            onClick={onApply}
            disabled={disabled.apply}
          >
            Apply Filters
          </Button>
          <Button
            sx={{
              height: '36px',
              width: '100px',
              borderRadius: 2,
              marginTop: '10px',
            }}
            variant="outlined"
            onClick={onClear}
            disabled={disabled.clear}
          >
            Clear All
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default TableFilterToolbar;
